var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFootball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8839 8.23248L9.55808 6.90666L10.442 6.02278L11.7678 7.3486L12.5044 6.61203L13.3882 7.49591L12.6517 8.23248L13.9775 9.55831L13.0936 10.4422L11.7678 9.11637L10.8839 10.0003L12.2097 11.3261L11.3258 12.21L10 10.8841L9.11613 11.768L10.442 13.0938L9.55808 13.9777L8.23225 12.6519L7.49568 13.3885L6.6118 12.5046L7.34837 11.768L6.02254 10.4422L6.90643 9.55831L8.23225 10.8841L9.11613 10.0003L7.79031 8.67443L8.67419 7.79054L10 9.11637L10.8839 8.23248Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99999 18.9586C5.41628 18.9586 5.82831 18.9403 6.23534 18.9046L6.26653 18.9358L6.3039 18.8985C13.4015 18.2409 18.9583 12.2695 18.9583 5.00022C18.9583 3.92293 18.8362 2.87338 18.6047 1.86499L18.5171 1.48329L18.1354 1.39567C17.1269 1.16417 16.0773 1.04199 15 1.04199C7.29102 1.04199 1.04166 7.29135 1.04166 15.0003C1.04166 16.0776 1.16382 17.1272 1.3953 18.1356L1.48292 18.5173L1.86462 18.6049C2.87305 18.8364 3.92264 18.9586 4.99999 18.9586ZM13.305 2.40405C7.61724 3.16213 3.11892 7.6822 2.39394 13.3803L2.43637 13.3379L6.69497 17.5965C12.3577 16.8418 16.8415 12.3581 17.5963 6.69534L13.305 2.40405ZM14.9607 2.29205L17.7083 5.03958L17.7083 5.00022C17.7083 4.15503 17.6259 3.32966 17.4688 2.53152C16.6706 2.37442 15.8452 2.29199 15 2.29199L14.9607 2.29205ZM2.29166 15.0003L2.29172 14.961L5.0392 17.7085L4.99999 17.7086C4.15475 17.7086 3.32933 17.6261 2.53116 17.469C2.37408 16.6709 2.29166 15.8455 2.29166 15.0003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFootball);
export default __webpack_public_path__ + "static/media/ic_football.b8b3249c8cce48b566f48482e8a783a1.svg";
export { ForwardRef as ReactComponent };